module.exports = __webpack_public_path__ + "media/images/ln/horoscope_12-0af28a487c657298481f8d56665c310b.png";